import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiClient from "services/api";
import Swal from "sweetalert2";
import {
  Grid,
  Card,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import ReactJson from "react-json-view";

function DocumentDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [imageBase64, setImageBase64] = useState(null);
  const [document, setDocument] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState("");
  const [noted, setNoted] = useState("");
  const [parsedData, setParsedData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        const doc = await apiClient.getDocumentById(id);
        setDocument(doc);
        setApprovalStatus(doc.status_approval || "");
        setNoted(doc.noted || "");
        setParsedData(doc.parsed_data || {});
        setImageBase64(doc.image_base64 || null);
      } catch (error) {
        console.error("Failed to load document detail", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDocument();
  }, [id]);

  const handleParsedDataChange = (edit) => {
    setParsedData(edit.updated_src);
  };

  const handleUpdate = async () => {
    if (!approvalStatus) {
      Swal.fire("Warning", "Please select approval status first.", "warning");
      return;
    }

    try {
      await apiClient.updateDocument(id, {
        status_approval: approvalStatus,
        noted: noted,
        parsed_data: parsedData,
      });

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Documents Updated",
        timer: 1500,
        showConfirmButton: false,
      }).then(() => {
        navigate("/documents");
      });
    } catch (error) {
      console.error("Gagal memperbarui dokumen:", error);
      Swal.fire("Gagal", "Gagal memperbarui dokumen", "error");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card>
              <MDBox p={3}>
                <MDTypography variant="h6" mb={2}>
                  Document Preview
                </MDTypography>
                {imageBase64 ? (
                  <img
                    src={`data:image/png;base64,${imageBase64}`}
                    alt="Document Preview"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                ) : (
                  <p>Preview tidak tersedia</p>
                )}
              </MDBox>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card>
              <MDBox p={3}>
                {!loading && document ? (
                  <>
                    <MDTypography variant="h6">Parsed Data</MDTypography>
                    <Box mt={2} sx={{ maxHeight: "400px", overflowY: "auto" }}>
                      <ReactJson
                        src={parsedData}
                        onEdit={handleParsedDataChange}
                        onAdd={handleParsedDataChange}
                        onDelete={handleParsedDataChange}
                        displayDataTypes={false}
                        enableClipboard={false}
                        collapsed={false}
                      />
                    </Box>
                    <FormControl fullWidth sx={{ mt: 3 }}>
                      <InputLabel id="approval-status-label">Approval Status</InputLabel>
                      <Select
                        labelId="approval-status-label"
                        value={approvalStatus}
                        label="Approval Status"
                        onChange={(e) => setApprovalStatus(e.target.value)}
                      >
                        <MenuItem value="Approved">Approved</MenuItem>
                        <MenuItem value="Revision">Revision</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      label="Catatan"
                      fullWidth
                      multiline
                      rows={3}
                      value={noted}
                      onChange={(e) => setNoted(e.target.value)}
                      sx={{ mt: 2 }}
                    />
                    <MDButton color="info" variant="gradient" sx={{ mt: 3 }} onClick={handleUpdate}>
                      Simpan
                    </MDButton>
                  </>
                ) : (
                  <MDTypography>Loading detail dokumen...</MDTypography>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default DocumentDetail;
